import EcosiaUser from '@ecosia/ecosia-user';

import { MAIN as MAIN_COOKIE } from '~~/common/js/constants/cookies';
import { sendEvent } from '~~/common/js/client/analytics';

const isExtensionMessage = (event) => window.location.href.indexOf(event.origin) === 0;

export default (context) => {
  if (process.server) {
    return;
  }

  // This overwrites any existing ECFG cookie in 'ecosiaUser' magic
  const cookieString = context.app.$cookies.get(MAIN_COOKIE);
  const user = new EcosiaUser({
    cookieString,
    acceptLanguage: navigator.language,
    userAgent: navigator.userAgent,
  });
  user.setFlowStage();

  window.addEventListener('message', (event) => {
    if (isExtensionMessage(event)) {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch (err) {
        return;
      }
      if (!data || typeof data !== 'object') {
        return;
      }

      if (data.event === 'firstSearch') {
        user.set('firstRun', 1);
        user.set('addOn', 1);
        sendEvent('addon_install', { addon: data.addon, version: data.version });
        sendEvent('first_search_after_install', {
          addon: data.addon,
          version: data.version,
          position: 'legacy_addon',
        });
      }

      if (data.event === 'version') {
        sendEvent('addon_present', { addon: data.addon, version: data.version });
      }
    }
  });
};
